import Joi from '@hapi/joi'

export const SundryLabourCheckListSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    estateID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Select Operation Entity`,
        "any.required": `Operation Entity required`
    }),
    divisionID: Joi.number().invalid(0).label("Collection Point").messages({
        "any.invalid": `Select Collection Point`,
        "any.required": `Collection Point required`
    }),
    fieldID: Joi.number().invalid(0).label("Field").messages({
        "any.invalid": `Select Field`,
        "any.required": `Field Required`
    }),
    searchDate: Joi.string().invalid("").label("Search Date"),




}

